import { action, makeObservable, observable } from 'mobx';
import { Store } from '../../store/store';
import { Message, StoreNode } from '../../store';
import { WindowState } from '../../components/overlays';
import { LibraryProvider } from '../../services/libraries/libraryServiceBase';

export class CredentialsExpiredWindowState
  extends StoreNode {

  readonly nodeType = 'CredentialsExpiredWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      library: observable,
      windowListener: action,
      open: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);

  isLoading: boolean = false;
  library: LibraryProvider | null = null;

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  open({ library }: { library: LibraryProvider }) {
    this.dispatch('Overlays', 'openWindow', { name: 'CredentialsExpiredWindow' });

    this.library = library;
  }

  close() {
    this.library = null;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}